var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDueDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.71429 3.07142H7.25M2.40476 0.5V1.27152M7.5 0.5V1.27142M9 4.27142L9 6.5C9 8.15685 7.65685 9.5 6 9.5H4C2.34315 9.5 1 8.15685 1 6.5V4.27142C1 2.61457 2.34315 1.27142 4 1.27142H6C7.65685 1.27142 9 2.61457 9 4.27142Z",
    stroke: "#E77B7B",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDueDateIcon);
export default __webpack_public_path__ + "static/media/due_date_Icon.855adeb1fb714ba1efc338d4ba38f64d.svg";
export { ForwardRef as ReactComponent };